import { useState } from 'react';
import { api, errorMessage } from '../../shared/api/client';
import { Alert, Button } from '../../shared/ui/components';

type Ref = { personId: string; name: string };
export type Band = { canEdit: boolean; positions: { id: string; name: string; variable: boolean; holders: Ref[]; people: Ref[] }[] };

/** Equipo de Alabanza del culto: los puestos permanentes con quienes los tienen; en los variables, el líder elige quién toca. */
export function BandSection({ base, band, onSaved }: { base: string; band: Band; onSaved: () => void }) {
  const [editing, setEditing] = useState<string | null>(null);
  if (band.positions.length === 0) return null;
  return (
    <div className="program-band">
      <h3 className="small">Equipo</h3>
      <ul className="list">
        {band.positions.map((p) => (
          <li key={p.id} className="list__item service">
            <div className="service__main">
              <strong>{p.name}</strong>
              <span className="small">
                {p.people.length ? p.people.map((x) => x.name).join(', ') : <span className="muted">{p.variable ? 'Por elegir' : 'Sin asignar'}</span>}
              </span>
              {editing === p.id ? (
                <PickForm
                  url={`${base}/band/${p.id}`}
                  position={p}
                  onDone={(ok) => {
                    setEditing(null);
                    if (ok) onSaved();
                  }}
                />
              ) : null}
            </div>
            {band.canEdit && p.variable && editing !== p.id ? (
              <Button type="button" variant="ghost" onClick={() => setEditing(p.id)}>
                Elegir
              </Button>
            ) : null}
          </li>
        ))}
      </ul>
    </div>
  );
}

function PickForm({ url, position: p, onDone }: { url: string; position: Band['positions'][number]; onDone: (ok: boolean) => void }) {
  const [chosen, setChosen] = useState(() => new Set(p.people.map((x) => x.personId)));
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  async function save() {
    setBusy(true);
    setError(null);
    try {
      await api.put(url, { personIds: [...chosen] });
      onDone(true);
    } catch (err) {
      setError(errorMessage(err));
      setBusy(false);
    }
  }
  return (
    <div className="form">
      {error ? <Alert>{error}</Alert> : null}
      {p.holders.length === 0 ? <p className="muted small">Nadie tiene este puesto todavía. Asígnalo en Ministerios → Alabanza → Puestos.</p> : null}
      {p.holders.map((h) => (
        <label key={h.personId} className="check">
          <input
            type="checkbox"
            checked={chosen.has(h.personId)}
            onChange={(e) =>
              setChosen((s) => {
                const next = new Set(s);
                if (e.target.checked) next.add(h.personId);
                else next.delete(h.personId);
                return next;
              })
            }
          />{' '}
          {h.name}
        </label>
      ))}
      <div className="actions">
        <Button type="button" busy={busy} onClick={() => void save()}>
          Guardar
        </Button>
        <Button type="button" variant="ghost" onClick={() => onDone(false)}>
          Cancelar
        </Button>
      </div>
    </div>
  );
}
